import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';
import moment from 'moment';

export interface IFuelSurcharge extends IBaseEntity {
    id?: number;
    effectiveFromDate: any;
    effectiveFromTime: any;
    baseFuelPrice?: number;
    proportionOfCostBase?: number;
    currentFuelPrice?: number;
    percentage?: number;
    calculatePercentage: boolean;
    flatRate?: number;
    useFlatRate: boolean;
    deleted: boolean;
    fuelSurchargeGroupId: number;
}

export class FuelSurcharge extends BaseEntity implements IFuelSurcharge {
    public id?: number;
    public effectiveFromDate: any;
    public effectiveFromTime: any;
    public baseFuelPrice?: number;
    public proportionOfCostBase?: number;
    public currentFuelPrice?: number;
    public percentage?: number;
    public calculatePercentage: boolean;
    public flatRate?: number;
    public useFlatRate: boolean;
    public deleted: boolean;
    public fuelSurchargeGroupId: number;

    constructor(fuelSurcharge?: any) {
        super();
        if (fuelSurcharge) {
            this.id = fuelSurcharge.id;
            // Effective-from is a wall clock (backend LocalDateTime) - parse it as local, never as UTC.
            this.effectiveFromDate = fuelSurcharge.effectiveFromDate ? moment(fuelSurcharge.effectiveFromDate).toDate() : null;
            this.effectiveFromTime = fuelSurcharge.effectiveFromTime ? moment(fuelSurcharge.effectiveFromTime).toDate() : this.effectiveFromDate;
            this.baseFuelPrice = fuelSurcharge.baseFuelPrice ? parseFloat(fuelSurcharge.baseFuelPrice) : null;
            this.proportionOfCostBase = fuelSurcharge.proportionOfCostBase ? parseFloat(fuelSurcharge.proportionOfCostBase) : null;
            this.currentFuelPrice = fuelSurcharge.currentFuelPrice ? parseFloat(fuelSurcharge.currentFuelPrice) : null;
            this.percentage = fuelSurcharge.percentage ? parseFloat(fuelSurcharge.percentage) : null;
            this.calculatePercentage = fuelSurcharge.calculatePercentage;
            this.flatRate = fuelSurcharge.flatRate ? parseFloat(fuelSurcharge.flatRate) : null;
            this.useFlatRate = fuelSurcharge.useFlatRate;
            this.deleted = fuelSurcharge.deleted;
            this.fuelSurchargeGroupId = fuelSurcharge.fuelSurchargeGroupId;
        }
    }

    get discriminator(): any {
        return this.id;
    }

    clone(): FuelSurcharge {
        return new FuelSurcharge(this);
    }
}
